import React from "react";

const SimpleRiver = () => {
    return (
        <div>
            <h1>Simple River</h1>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/MZPtXZWWBgw?si=XyT3LZahhIIMvMLI"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>
            <p><a href="https://assetstore.unity.com/preview/397256/1434372">Asset Store Link </a></p>

            Simple River generates a river mesh from any Unity spline and pairs it with a configurable Shader Graph
            water material. Draw a spline, add the component, adjust a few parameters, and you have a shaded, animated
            river running through your scene.

            The river's appearance is fully customizable through its Shader Graph material - colors, wave behavior,
            foam, and flow are all exposed properties, so the river can look exactly the way your project needs it to.
            Four ready-made styles are included to start from: Toon, Murky, Blood, and Ice.
        </div>
    )
        ;
};

export default SimpleRiver;
